import { render } from "./SalesnStatusTracking.vue?vue&type=template&id=5fc81926&scoped=true"
import script from "./SalesnStatusTracking.vue?vue&type=script&lang=js"
export * from "./SalesnStatusTracking.vue?vue&type=script&lang=js"

import "./SalesnStatusTracking.vue?vue&type=style&index=0&id=5fc81926&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc81926"]])

export default __exports__